import { useState, useEffect } from 'react'
import { Flex } from '@radix-ui/themes'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { Checkbox } from '@/components/subscription/checkbox'
import { SubscriptionInventory, SubscriptionSchedule } from '~/api-client/data-contracts'
import * as styles from './styles.css'

type Props = {
  schedules: SubscriptionSchedule[]
  selectedInventories: SubscriptionInventory[]
  onChange: (inventoryIds: string[]) => void
}

function formatDeliverWeekday(schedule: SubscriptionSchedule) {
  return format(new Date(1000 * schedule.attributes.deliver_at[0]), 'EEEE', { locale: ja })
}

export const ScheduleSelector: React.FC<Props> = ({ schedules, selectedInventories, onChange }) => {
  const options = Object.groupBy(schedules, (schedule) => formatDeliverWeekday(schedule))
  const weekdays = Object.keys(options).sort((w) => (w === '水曜日' || w === '木曜日' ? -1 : 1))

  const [weekday, setWeekday] = useState<string>(() => {
    if (selectedInventories.length === 0) {
      return weekdays[0]
    } else {
      return formatDeliverWeekday(schedules.find((s) => s.relationships.inventory.data.id === selectedInventories[0].id))
    }
  })

  useEffect(() => {
    handleFreqChange(selectedInventories.length || 1)
  }, [weekday])

  const handleFreqChange = (time: number) => {
    let inventories = []

    if (time === 1) inventories = [options[weekday][0]]
    if (time === 2) inventories = [options[weekday][0], options[weekday][2]]
    if (time === 4) inventories = options[weekday]

    onChange(inventories.map((s) => s.relationships.inventory.data.id))
  }

  return (
    <>
      {weekdays.length > 1 && (
        <div className={styles.card}>
          <Flex direction="column" align="start" gap="4px">
            <p className={styles.heading}>受け取りたい曜日を選んでください</p>
            <Flex direction="column" align="start" gap="4px">
              {weekdays.map((day, index) => (
                <Checkbox key={index} checked={weekday === day} onChange={() => setWeekday(day)}>
                  {day}
                </Checkbox>
              ))}
            </Flex>
          </Flex>
        </div>
      )}
      <div className={styles.card}>
        <Flex direction="column" align="start" gap="4px">
          <p className={styles.heading}>受け取りたい頻度を選んでください</p>
          <Flex direction="column" align="start" gap="4px">
            {[1, 2, 4].map((time) => (
              <Checkbox key={time} checked={selectedInventories.length === time} onChange={() => handleFreqChange(time)}>
                月に{time}回
              </Checkbox>
            ))}
          </Flex>
          <p className={styles.note}>※1配送ごとに2,970円がかかります</p>
        </Flex>
      </div>
    </>
  )
}
